import { render, staticRenderFns } from "./SectionContestCurrentComponent.vue?vue&type=template&id=b87bd9e4"
import script from "./SectionContestCurrentComponent.vue?vue&type=script&lang=js"
export * from "./SectionContestCurrentComponent.vue?vue&type=script&lang=js"
import style0 from "./SectionContestCurrentComponent.vue?vue&type=style&index=0&id=b87bd9e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports